import React, { useState, useEffect } from "react";
import DetallesPlanCosechaEntrada from "./DetallesPlanCosechaEntrada";
import HistorialEstados from "./HistorialEstados";
import { PHP_API } from "../../utils/Common";
import axios from "axios";

const AclimatacionEstadoLista = (props) => {
   const [planes, setplanes] = useState([...props.data]);
   const [idDetalles, setidDetalles] = useState();
   const [modif, setmodif] = useState([]);
   const [showHistory, setshowHistory] = useState(false);
   const [loader, setloader] = useState(false);
   const [history, sethistory] = useState([]);

   useEffect(() => {
      prepararModif();
   }, []);

   const abrirHistorial = (id) => {
      setloader(true);
      axios.post(`${PHP_API}HistorialEstatusvivero`, { id: id, estatus: 1 }).then((resp) => {
         setloader(false);
         sethistory([...resp.data]);
         setshowHistory(true);
      }).catch((e) => { setloader(false) })

   }

   const mostrar_ocultar_detalles = (id) => {
      if (!id || idDetalles == id) setidDetalles(-1);
      else setidDetalles(id);
   }

   const verificaractualizar = () => {
      let nuevas = [...props.data];
      if (nuevas.length != planes.length) return true;
      for (let i = 0; i < nuevas.length; i++) {
         if (nuevas[i].id != planes[i].id || nuevas[i].aclimatacionCantidad != planes[i].aclimatacionCantidad || nuevas[i].total_aclimatacion != planes[i].total_aclimatacion) return true;
      }
      return false;
   }

   const actualizar = () => {
      if (verificaractualizar()) {
         for (let i = 0; i < planes.length; i++) {
            let inp = document.getElementById(`input${i}`);
            if (inp) inp.value = 0;
         }
         setplanes([...props.data]);
         prepararModif();
      }
   }

   const prepararModif = () => {
      let dat = props.data ?? [];
      let modify = [];
      for (let i = 0; i < dat.length; i++) {
         modify.push({
            aclimatacionCantidad: dat[i].aclimatacionCantidad,
            modif: 0,
            error: false
         });
      }
      setmodif(modify);
   }

   const agregarValor = (i, valor) => {
      let modify = [...modif];
      let pl = [...planes];

      modify[i].modif = (valor == '') ? 0 : parseFloat(valor);
      modify[i].error = detectarErrores(pl[i], (valor == '') ? 0 : parseFloat(valor), modify[i].aclimatacionCantidad ?? 0);
      pl[i].aclimatacionCantidad = modify[i].modif + modify[i].aclimatacionCantidad;


      if (puedoSubir(modify)) {
         props.save(true, modify);
         setplanes([...pl]);
      } else {
         props.save(false, []);
         setplanes([...pl]);
      }
   }

   //Verifica que el valor que se trata de agregar +  e;l valor del estado anterior no sea menor ni mayior a la suma de este
   const detectarErrores = (original, agregado) => {

      if (original.germinacion_real <= 0) return "La germinación real debe ser superior a cero para poder agregar cantidades";

      //Primero convertimos las charolas de aclimatacionn al numero de plantas equivalentes
      let a_ingresar = original.charolas_germinadas;
      let incertudumbre = original.germinacion_real * 288 * 5; //se permite 1/4 de charola de inscertidumbre al entegar
      //Verificar que la nueva cantidad no vuelva el valor de ingreso a simebra menor a cero
      let suma = +original.charolas_germinadas + +agregado;
      if (suma < 0) return `El total en aclimatación no puede ser inferior a cero`;

      //Verificar que lo que entra a aclimatación no sea mayor a los que se sembró
      if ((+original.total_ejecutado - suma) < -incertudumbre) return 'No se pueden reportar mas charolas en aclimatación de las que se reportaron en siembra';
      if ((original.aclimatacionEntradas > suma)) return 'El total registrado en aclimatación no puede ser inferior al registrado en entrega';

      return false;
   }

   //detecta si existe algun error que impida activar el boton se subida
   const errorExiste = (modifs) => {
      for (let i = 0; i < modifs.length; i++)
         if (modifs[i].error) return true;
      return false;
   }

   //Deteecta si existe algun cambio y que no existan errores para activar el boton de subida
   const puedoSubir = (modify) => {
      if (errorExiste(modify)) return false;
      for (let j = 0; j < modify.length; j++) {
         if (modify[j].modif != 0) return true;
      }
      return false;
   }

   const mostrarHistorial = (id) => {
      setshowHistory(true);
      abrirHistorial(id);
   }

   const separador = () => { return (<span className="ms-2 me-2 text-900" style={{ color: "#BBBBBB" }}>|</span>) }
   const superhabitColor = (values) => {
      for (let i = 0; i < values.length; i++) if (values[i] < 0) return "text-blue3 text-bold";
      return '';
   }

   /**
    * Retorna las diferencias en semanas entre la semana de siembra planeada y la semana de ejecución
    * @param {object} p - un elemento del plan de siembra de la lista alojada en data
    * @returns {number} numero de semanas de diferencia respecto a semana de siembra planeada
   */
   const diferencia = (p) => {
      if (p.semana_ejecucion && p.fecha_inicio) {
         let inicio = new Date(p.fecha_inicio);
         let ejecucion = new Date(p.fecha_semana_ejecucion);

         let diferencia = ejecucion - inicio;
         let dias = diferencia / (1000 * 60 * 60 * 24);
         let semanas = dias / 7;
         return Math.floor(semanas);
      }
      return 0;
   }

   actualizar();
   return (
      <div className="col-lg-12 p-0 m-0 p-0" style={{ overflow: 'auto', height: '80vh' }}>
         <table className="table table-sm table-hover table-bordered p-0">
            <thead className="bg-orange-900 text-white m-0 p-0">
               <tr >
                  <th className='text-center nowrap'>Información</th>
                  <th className='text-center nowrap'>Historial</th>
                  <th className="text-center nowrap">Flor Variedad color</th>
                  <th className="text-center nowrap text-s">Sem. siembra </th>
                  <th className="text-center nowrap text-s">Sem. ejecución</th>
                  <th className="text-center nowrap text-s">Sem. Transplante</th>

                  <th className="text-center nowrap p-0 m-0">
                     <div className='col-lg-12 p-0 m-0 text-center ps-2 pe-2'>
                        <p className="p-0 m-0 text-s">Plan de siembra</p>
                        <p className="p-0 m-0 text-xs text-bold">Plantas{separador()}charolas</p>
                     </div>
                  </th>

                  <th className="text-center nowrap p-0 m-0">
                     <div className='col-lg-12 p-0 m-0 text-center ps-2 pe-2'>
                        <p className="p-0 m-0 text-s">Ejecución de siembra</p>
                        <p className="p-0 m-0 text-xs text-bold">Plantas{separador()}Charolas{separador()}Gm. programa</p>
                     </div>
                  </th>

                  <th className="text-center nowrap p-0 m-0">
                     <div className='col-lg-12 p-0 m-0 text-center ps-2 pe-2'>
                        <p className="p-0 m-0 text-s">Monitoreo de germinación</p>
                        <p className="p-0 m-0 text-xs text-bold">Plantas{separador()}Charolas{separador()}Gm. DDS</p>
                     </div>
                  </th>
                  <th className="text-center nowrap p-0 m-0">
                     <div className='col-lg-12 p-0 m-0 text-center ps-2 pe-2'>
                        <p className="p-0 m-0 text-s">Falta por monitorear</p>
                        <p className="p-0 m-0 text-xs text-bold">Plantas{separador()}Charolas{separador()}Gm. DDS</p>
                     </div>
                  </th>
                  <th className='text-center text-xs nowrap'>Gm. DDS</th>
                  <th className='text-center text-xs nowrap'>Agregar charolas</th>
               </tr>
            </thead>
            <tbody>
               {planes.map((p, i) => {
                  let bgRetrasado = diferencia(p) > 0 ? ' rosa-retrasado border border-white' : '';
                  return (
                     < React.Fragment key={i + 'dfgerge'}>
                        <tr >
                           <td className="text-center">
                              <button className='btn btn-sm round-xxs btn-light shadow scale-05' onClick={() => { mostrar_ocultar_detalles(p.id) }}>Detalles</button>
                           </td>
                           <td className="tex-center nowrap text-s m-0 p-0">
                              <div className='col-lg-12 text-center m-0 p-1' >
                                 <button className={`btn btn-sm btn-light shadow text-s m-0  ${p.aclimatacionEntradas && p.aclimatacionEntradas > 0 ? "" : " disabled"}`} onClick={() => { mostrarHistorial(p.id); }}>
                                    ({p.aclimatacionEntradas}) <i className="fa fa-history me-1 ms-1" aria-hidden="true"></i>
                                 </button>
                              </div>
                           </td>
                           <td className="text-center nowrap text-s">
                              <p className={`${p.completo === 1 ? 'text-success' : 'text-floricents'} text-bold ` + bgRetrasado}>{p.bloque}</p>
                           </td>
                           <td className="text-center nowrap text-s">{p.semanainicio}</td>
                           <td className={"text-center nowrap text-s" + bgRetrasado}>{p.semana_ejecucion ?? '-'}</td>
                           <td className="text-center nowrap text-s">{p.transplante}</td>
                           <td className=" text-300 bw-200 text-s text-center">
                              {Math.floor(+p.plantas)}{separador()}{Math.floor(+p.charolas)}
                           </td>

                           <td className="text-center text-s">{Math.floor(p.plantas_ejecutado)}{separador()}{Math.floor(p.total_ejecutado)}{separador()}{p.por_germinacion}%</td>
                           <td className={"text-center text-s " + superhabitColor([p.total_aclimatacion - p.total_entregado, p.charolas_restantes_en_vivero])}>
                              {Math.abs(Math.floor(p.total_aclimatacion - p.total_entregado))}{separador()}{Math.abs(Math.floor(p.charolas_restantes_en_vivero))}{separador()}{p.germinacion_real}%
                           </td>
                           <td className={"text-center text-s " + superhabitColor([p.germinacion_real <= 0 ? 0 : ((p.total_ejecutado * 288 * p.germinacion_real) - p.total_aclimatacion), p.germinacion_real <= 0 ? 0 : (p.total_ejecutado - p.charolas_aclimatacion)])}>
                              {p.germinacion_real <= 0 ? 0 : Math.abs(Math.floor((p.total_ejecutado * 288 * p.germinacion_real) - p.total_aclimatacion))}{separador()}
                              {p.germinacion_real <= 0 ? 0 : Math.abs(Math.floor(p.total_ejecutado - p.charolas_aclimatacion))}{separador()}
                              {p.germinacion_real}%
                           </td>

                           <td className=" nowrap text-xs p-0">
                              <div className='col-lg-12 m-0 p-1 contenedor'>
                                 <input
                                    id={i}
                                    className="form-control form-control-sm text-center p-0 m-0"
                                    type="number"
                                    step="any"
                                    name="germinacion_real"
                                    placeholder={p.germinacion_real}
                                    onChange={(e) => { props.cambiarGermiancion(e.target.value, i, 'germinacion_real'); }} />
                              </div>
                           </td>

                           <td className='col-auto p-1 m-0 text-center container'>
                              <input type='number' className='form-control text-center form-control-sm p-0 m-0' onChange={(e) => { agregarValor(i, e.target.value) }} id={`input${i}`} disabled={p.germinacion_real <= 0} />
                           </td>
                        </tr>
                        {/*{p.germinacion_real}% */}
                        {idDetalles == p.id && <DetallesPlanCosechaEntrada key={i + "indexEdicionD"} data={p} index={i} close={mostrar_ocultar_detalles} span={11} />}
                        {modif[i] && modif[i].error && <tr className='p-0 m-0'>
                           <td key={i + "indexEdicionDDD"} className='text-center text-danger text-s pt-0 pb-3 m-0' colSpan="11">{modif[i].error}</td>
                        </tr>}
                     </React.Fragment>
                  );
               })}
            </tbody>
         </table>
         {showHistory && <HistorialEstados cerrar={() => { setshowHistory(false); sethistory([]); }} data={[...history]} />}
         {loader && <div className="frontal-blur-transparent">
            <div className="loader"></div></div>}
      </div>
   )
}
export default AclimatacionEstadoLista;